import Loader from 'components/Loader'
import React, { lazy, Suspense, useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'

const FormClientProviderGnv = lazy(async () => import('./RegistroClienteGnv'))
const GestionVehiculosGnv = lazy(async () => import('./GestionVehiculosGnv'))
const GestionRecaudosGnv = lazy(async () => import('./GestionRecaudosGnv'))
const Visor = lazy(async () => import('./Visor'))
const Monitor = lazy(async () => import('./Monitor'))
const SincronizacionVehiculos = lazy(async () => import('./SincronizacionVehiculos'))
//rutas

const Gnv = ({ match }: any) => {


  return (
    <div className="app-wrapper">
      <Switch>
        <Suspense fallback={<Loader />}>
          <Route path={`${match.url}/clientes_gnv`} component={FormClientProviderGnv} />
          <Route path={`${match.url}/vehiculos_gnv`} component={GestionVehiculosGnv} />
          <Route path={`${match.url}/registro_recaudos_clientes`} component={GestionRecaudosGnv} />
          <Route path={`${match.url}/visor`} component={Visor} />
          <Route path={`${match.url}/monitor`} component={Monitor} />
          <Route path={`${match.url}/sincronizacion_vehiculos`} component={SincronizacionVehiculos} />
        </Suspense>
      </Switch>
    </div>
  )
}

export default Gnv
